import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from 'src/app/services/app.service';
import { ApiService } from 'src/app/services/api.service';
import { CartService } from 'src/app/services/cart.service';

@Component({
  selector: 'dm-cart-item-eliminar-modal',
  templateUrl: './dm-cart-item-eliminar-modal.component.html',
  styleUrls: ['./dm-cart-item-eliminar-modal.component.scss']
})
export class DmCartItemEliminarModal implements OnInit {

  public item:any = {}; 
  public loader = false;

  constructor(
    public dialog: MatDialogRef<DmCartItemEliminarModal>,
    @Inject(MAT_DIALOG_DATA) public data,
    private app: AppService,
    private api: ApiService,
    private CartService: CartService
  ){ 

    this.item = this.data.item;

  }
  /**
   * 
   * Close modal
   * 
   */
  _close(){

    this.dialog.close();

  }
  /**
   * 
   * Update Cart
   * 
   */
  updateCart(){

    this.CartService.emitirDeleteItem.emit(this.item.id)
    this.app.toTop();
  }
  /**
   * 
   * Deleta o serviço
   * 
   * 
   */
  deletar(){ 

    try{

      this.loader = true; 

      this.api.cart().delete(this.item.id).subscribe(response=>{

        this.loader = false;

        if(response.status == 1){
          
          this._close();
          this.updateCart();
        
        }else{

          this.app.info("Houve um erro ao deletar o serviço. Tente novamente.");

        }

      }, (response) => {

        this.loader = false;
        this.app.info("Houve um erro ao deletar o serviço. Tente novamente.");

      });
      

    }catch(e){

      this.loader = false;

    }

  }
  /**
   * 
   * Inicializa as Funções
   * 
   */
  ngOnInit():void{}

}
